

  <div class="log" style="padding-top:130px;">
    <div class="input-cont">
    <h2 stlye="text-align-left prox" style="font-family: 'proxima-nova'; " >Sign up</h2>
    </div>
    <div class="authBlock">
      <div class="input-cont formGroup">
        <input type="text" #firstName required class="formControl" placeholder="First Name" style="font-size: 16px;">
        <!-- <label>First name</label> -->
        <div class="border1"></div>
      </div>
      <div class="input-cont formGroup">
        <input id="lastName" type="text" #lastName required class="formControl" placeholder="Last Name" style="font-size: 16px;">
        <!-- <label for="lastName">Last name</label> -->
        <div class="border1"></div>
      </div>
      <div class="input-cont formGroup">
        <input type="text"  #email required class="formControl" placeholder="Email address" style="font-size: 16px;">
        <!-- <label>Email address</label> -->
        <div class="border1"></div>
      </div>
      <div class="input-cont formGroup">
        <input type="password" #password required class="formControl" placeholder="Password" style="font-size: 16px;" >
        <!-- <label>Password</label> -->
        <div class="border2"></div>
      </div>
      <div style="height: 32px;"></div>
      <div class="input-cont formGroup">
      <button type="button" style="font-family: 'proxima-nova';" class="button btn-lg btn-block" (click)="authenticationService.SignUp(email.value, password.value, firstName.value + ' ' + lastName.value )">Create a new account</button>
      </div>
    </div>
  </div>

